import React from "react";
import { bikes } from "../data.js";
import Bike from "./ui/Bike.jsx";
// console.log(books);

const New = () => {
  // console.log(process.env.BIKE_SHOP_API_KEY);

  return (
    <section id="recent">
      <div className="container">
        <div className="row">
          
          <h2 className="section__title">
            New <span className="purple">Items</span>
          </h2>
          {/* <span className="badge inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs front-medium text-red-700 ring-1 ring-inset ring-red-600/10">
            New
          </span> */}
          <div className="bikes">
              {/* find the new bikes from item */}
              {bikes
                .filter((bike) => bike.item)
                .slice(0, 8)
                .map((bike) => (
                  <Bike bike={bike} key={bike.id} />
                ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default New;
